import { Node } from "@tiptap/core";
import { DOCUMENT_VARIABLE_LABELS } from "@shared/entities/documentVariables";
import type { TDocumentVariableKey } from "@shared/entities/documentVariables";

export const VariableNode = Node.create({
  name: "variable",

  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      key: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-variable-key"),
        renderHTML: (attributes) => ({
          "data-variable-key": attributes.key as string,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-variable-key]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const key = HTMLAttributes["data-variable-key"] as TDocumentVariableKey | null;
    const label = key && key in DOCUMENT_VARIABLE_LABELS
      ? DOCUMENT_VARIABLE_LABELS[key]
      : (key ?? "");

    return [
      "span",
      {
        ...HTMLAttributes,
        class:
          "inline-flex items-center px-2 py-0.5 rounded bg-primary-100 text-primary-800 text-sm font-medium mx-0.5 select-all",
        contenteditable: "false",
      },
      label,
    ];
  },

  addKeyboardShortcuts() {
    return {};
  },
});
